import React, { useState } from 'react';
import classNames from 'classnames';
import { getISOWeek, getQuarter, parse } from 'date-fns';
import { getMonthName } from '../../utils';
import axios from 'axios';
import fileDownload from 'js-file-download';

const getFileType = (url) => {
    const UNKNOWN = 'unknown';
    if (!url) return UNKNOWN;

    let dotIndex = url.lastIndexOf('.');
    let ext = url.substring(dotIndex + 1);

    if (dotIndex === -1) return UNKNOWN;

    return ext;
};

export const Terms = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly'
};

export const getLabel = ({ report_date, term }) => {
    const date = parse(report_date);
    const month = date.getMonth();
    const record_term = term.toLowerCase();
    if (record_term === Terms.MONTHLY) return `${getMonthName(month).name}, ${date.getFullYear()}`;
    if (record_term === Terms.QUARTERLY) return `${date.getFullYear()}-Q${getQuarter(date)}`;
    return `${date.getFullYear()}-W${getISOWeek(date)}`;
};

export const DownloadReportButton = ({ report, label, className = '' }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const [downloadError, setDownloadError] = useState(false);

    const _label = label || `Download (${getFileType(report.filename)})`;

    const handleDownloadReport = async ({ filename, download_url }) => {
        setIsDownloading(true);
        setDownloadError(false);
        try {

            const downloadUrl = await axios.get(download_url);
            const signedUrl = await axios.get(downloadUrl.data.url, {transformRequest: (data, headers) => {
                delete headers.common['Authorization'];
                return data;
            }, responseType: 'blob'});

            await fileDownload(signedUrl.data, filename);
        } catch {
            setDownloadError(true);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <button
                type="button"
                className={classNames('btn mx-0', className)}
                onClick={() => handleDownloadReport(report)}
                disabled={isDownloading && !downloadError}
            >
                {!isDownloading && _label}
                {isDownloading && 'Downloading...'}
            </button>
            {downloadError && <small className="txt-danger d-block">Error downloading report, try again later.</small>}
        </>
    );
};